import { createConfirmation } from 'react-confirm'
import CenshareTranslationWarningDialog from '../../components/dialogs/CenshareTranslationWarning'

const censhareTranslationWarning = createConfirmation(CenshareTranslationWarningDialog)


export default function (confirmation, options = {}) {

  if (typeof confirmation !== 'string') {
    options = { ...confirmation }
    confirmation = ''
  }

  return censhareTranslationWarning({ confirmation, options })
}
